import { Button, Col, Form, Input, Row } from "antd";
import axios from "axios";
import React, { useState } from "react";
import { Success, Warning } from "../../../commons/Messages/Messages";

import { useTranslation } from "react-i18next";
const UpdatePassword = () => {
  const { t } = useTranslation("dashboard");
  const [loading, setLoading] = useState(false);

  const onFinish = async values => {
    setLoading(true);
    await axios
      .put(`${process.env.REACT_APP_BACKEND_URL}/users/change-password`, values, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      })
      .then(res => {
        setLoading(false);
        if (res.status === 200 || res.status === 304) {
          Success(res.data.successMessage);
        } else {
          Warning(res.data.errorMessage);
        }
      })
      .catch(err => {
        setLoading(false);
        Warning(err.message);
      });
  };

  const onFinishFailed = errorInfo => {};

  return (
    <>
      <Form
        size="large"
        name="basic"
        layout="vertical"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        style={{ maxWidth: 400, width: "100%" }}
      >
        <Row gutter={[10, 0]}>
          <Col xs={24} md={24}>
            <Form.Item
              label={t("Old Password")}
              name="oldPassword"
              rules={[
                {
                  required: true,
                  message: t("Please enter Old Password!")
                }
              ]}
            >
              <Input.Password autoComplete="current-password" />
            </Form.Item>
          </Col>
          <Col xs={24} md={24}>
            <Form.Item
              label={t("New Password")}
              name="password"
              hasFeedback
              rules={[
                {
                  required: true,
                  message: t("Please enter password!")
                }
              ]}
            >
              <Input.Password autoComplete="new-password" />
            </Form.Item>
          </Col>
          <Col xs={24} md={24}>
            <Form.Item
              name="confirm"
              label={t("Confirm Password")}
              dependencies={["password"]}
              hasFeedback
              rules={[
                {
                  required: true,
                  message: t("Please confirm your password!")
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error(t("passwordsDntMatch")));
                  }
                })
              ]}
            >
              <Input.Password autoComplete="new-password" />
            </Form.Item>
          </Col>
          <Col xs={24}>
            <Form.Item>
              <Button loading={loading} block type="primary" htmlType="submit">
                {t("Submit")}
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default UpdatePassword;
